import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getGlobalChat = () => {
  return axios.get(`${getBackendUrl()}/chat`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const sendGlobalChat = (message) => {
  return axios.post(`${getBackendUrl()}/chat`, message, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};
